import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import JobSearch from "./components/JobSearch";
import Solutions from "./components/Solutions";
import SalaryStudy from "./components/SalaryStudy";
import Expertise from "./components/Expertise";
import Articles from "./components/Articles";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import EmploisPage from "./pages/EmploisPage";
import DeposerCVPage from "./pages/DeposerCVPage";
import SolutionsPage from "./pages/SolutionsPage";
import RecrutementPage from "./pages/RecrutementPage";
import ConseilsCarrierePage from "./pages/ConseilsCarrierePage";
import ConseilsRecrutementPage from "./pages/ConseilsRecrutementPage";
import ArticleCarrierePage from "./pages/ArticleCarrierePage";
import ArticleRecrutementPage from "./pages/ArticleRecrutementPage";
import EtudeRemunerationPage from "./pages/EtudeRemunerationPage";
import AProposPage from "./pages/AProposPage";
import BureauxPage from "./pages/BureauxPage";
import EquipesPage from "./pages/EquipesPage";
import CarrieresPage from "./pages/CarrieresPage";
import ServicePage from "./pages/ServicePage";

import ExpertisePage from "./pages/ExpertisePage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";
import ConditionsUtilisationPage from "./pages/ConditionsUtilisationPage";
import CookiesPage from "./pages/CookiesPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";

// Home Page Component
const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <JobSearch />
        <Solutions />
        <SalaryStudy />
        <Expertise />
        <Articles />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/emplois" element={<EmploisPage />} />
          <Route path="/deposer-cv" element={<DeposerCVPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/recrutement" element={<RecrutementPage />} />
          <Route path="/conseils-carriere" element={<ConseilsCarrierePage />} />
          <Route path="/conseils-recrutement" element={<ConseilsRecrutementPage />} />
          <Route path="/conseils-carriere/:slug" element={<ArticleCarrierePage />} />
          <Route path="/conseils-recrutement/:slug" element={<ArticleRecrutementPage />} />
          <Route path="/etude-remuneration" element={<EtudeRemunerationPage />} />
          <Route path="/a-propos" element={<AProposPage />} />
          <Route path="/bureaux" element={<BureauxPage />} />
          <Route path="/equipes" element={<EquipesPage />} />
          <Route path="/carrieres" element={<CarrieresPage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/expertise/:slug" element={<ExpertisePage />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
          <Route path="/conditions-utilisation" element={<ConditionsUtilisationPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
